"use client";

import { useEffect } from "react";

/**
 * 处理页眉滚动行为的客户端组件：
 * - Scroll: 滚动超过阈值后添加 is-scrolled 类（固定 + 背景色 + 阴影）
 * - Fixed: 无需脚本，纯 CSS fixed
 * - Disappears: 向下滚动时 is-hidden，向上滚动时显示
 * - Fade Out: 向下滚动淡入淡出效果
 * - Standard: 无需脚本，纯 CSS sticky
 */
export function HeaderScrollBehaviour() {
  useEffect(() => {
    const header = document.querySelector<HTMLElement>(".topbar");
    if (!header) return;

    // 紧凑菜单 toggle 按钮交互
    const toggleBtn = header.querySelector<HTMLButtonElement>("[data-nav-toggle]");
    const dropdown = header.querySelector<HTMLElement>("[data-nav-dropdown]");
    if (toggleBtn && dropdown) {
      const onToggle = () => dropdown.classList.toggle("open");
      toggleBtn.addEventListener("click", onToggle);
    }

    if (header.classList.contains("header-standard") || header.classList.contains("header-fixed")) {
      // Standard (sticky) 或 Fixed 无需滚动脚本
      return () => {
        if (toggleBtn) {
          toggleBtn.removeEventListener("click", () => dropdown?.classList.toggle("open"));
        }
      };
    }

    let lastScrollY = window.scrollY;
    const THRESHOLD = 50;

    const onScroll = () => {
      const currentY = window.scrollY;
      const delta = currentY - lastScrollY;

      if (header.classList.contains("header-scroll")) {
        // 滚动模式：超过阈值才显示为 sticky
        if (currentY > THRESHOLD) {
          header.classList.add("is-scrolled");
        } else {
          header.classList.remove("is-scrolled");
        }
      } else if (header.classList.contains("header-disappears") || header.classList.contains("header-fadeout")) {
        // 忽略细微抖动
        if (Math.abs(delta) < 10) {
          lastScrollY = currentY;
          return;
        }
        if (delta > 0 && currentY > THRESHOLD) {
          // 向下滚动 -> 隐藏
          header.classList.add("is-hidden");
        } else {
          // 向上滚动 -> 显示
          header.classList.remove("is-hidden");
        }
      }

      lastScrollY = currentY;
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    // 初始检测
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (toggleBtn && dropdown) {
        toggleBtn.removeEventListener("click", () => dropdown.classList.toggle("open"));
      }
    };
  }, []);

  return null;
}
